export default __webpack_public_path__ + "static/PE-3-4de1edf13ff8bbfbb35e966033f239b4.png";